import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	reports: {
		id: 'spa-apps-sidebar-user.menu.reports.reports',
		defaultMessage: 'Reports',
		description: 'Navigation item which links to reports view',
	},
	allReports: {
		id: 'spa-apps-sidebar-user.menu.reports.all-reports',
		defaultMessage: 'All reports',
		description: 'Navigation item which links to all reports view',
	},
});
